// frontend/src/components/calendar/CalendarEvent.js
import React from 'react';
import { Box, Typography, Chip, alpha } from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import RedditIcon from '@mui/icons-material/Reddit';
import { PLATFORM_COLORS, STATUS_COLORS, PLATFORM_CONTENT_FIELD } from './CALENDAR_CONFIG';

const PLATFORM_ICONS = {
    youtube: YouTubeIcon,
    instagram: InstagramIcon,
    twitter: TwitterIcon,
    linkedin: LinkedInIcon,
    facebook: FacebookIcon,
    reddit: RedditIcon,
};

const CalendarEvent = ({ event }) => {
    const { resource } = event;
    const platforms = resource?.platforms || [];
    const status = resource?.status || 'scheduled';

    const primaryPlatform = platforms[0] || 'youtube';
    const primaryColor = PLATFORM_COLORS[primaryPlatform] || '#6366f1';
    const Icon = PLATFORM_ICONS[primaryPlatform] || YouTubeIcon;

    const contentField = PLATFORM_CONTENT_FIELD[primaryPlatform];
    const contentPreview = resource?.platformContent?.[primaryPlatform]?.[contentField] || '';

    return (
        <Box
            data-testid="calendar-event"
            data-event-id={event.id}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 0.75,
                py: 0.25,
                borderRadius: '4px',
                borderLeft: `3px solid ${primaryColor}`,
                background: alpha(primaryColor, 0.12),
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                    background: alpha(primaryColor, 0.22),
                    transform: 'translateY(-1px)',
                }
            }}
        >
            <Icon sx={{ fontSize: 14, color: primaryColor }} />

            <Typography
                variant="caption"
                noWrap
                sx={{
                    flex: 1,
                    fontSize: '0.7rem',
                    fontWeight: 500,
                    color: 'text.primary'
                }}
            >
                {contentPreview}
            </Typography>

            {platforms.length > 1 && (
                <Chip
                    label={`+${platforms.length - 1}`}
                    size="small"
                    sx={{
                        height: 14,
                        fontSize: '0.6rem',
                        bgcolor: 'action.selected',
                        '& .MuiChip-label': { px: 0.5 }
                    }}
                />
            )}

            <Box
                data-testid="event-status-dot"
                sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    bgcolor: STATUS_COLORS[status],
                    flexShrink: 0
                }}
            />
        </Box>
    );
};

export default CalendarEvent;
